import ModuleConfig from '../Config';
import { push } from 'connected-react-router';

const actions = ModuleConfig.Actions;
const endpoints = ModuleConfig.Endpoints;
const Catalog = ModuleConfig.Structures.Catalog;
const CRUDActions = ModuleConfig.CRUDActions;

export function getCatalog(opts = { start: 0, limit: 20 }, extras = {}) {
    return CRUDActions.getAll(actions.getAll, {
        ...opts,
        endpoint: endpoints.catalog,
        mapStructure: Catalog,
        errorNotification: 'Catalogul nu a putut fi încărcat'
    }, extras);
}

export function getCatalogItem(id) {
    return CRUDActions.getOne(actions.getOne, {
        id,
        endpoint: endpoints.catalogItem,
        mapStructure: Catalog,
        errorNotification: 'Articolul nu a putut fi încărcat'
    });
}

/**
 * Navigate to create product page with catalog item data pre-filled
 * @param {number} catalogId - The catalog item ID to create product from
 */
export function createProductFromCatalog(catalogId) {
    return (dispatch) => {
        dispatch(push(`/products/create?catalogId=${catalogId}`));
    };
}
